import { Injectable } from '@angular/core';
import { PersonType } from '../common/constants/person-type.enum';
import { OutgoingChatMessage } from 'common/xislivechat/models/outgoing-chat-message';
import { BoldIdGeneratorService } from 'common/bold-id-generator/bold-id-generator.service';

@Injectable({
  providedIn: 'root'
})
export class OutgoingChatMessageFactory {
  private _idGenerator;

  constructor () {
    this._idGenerator = BoldIdGeneratorService();
  }

  public createChatMessage(message) {
    const outgoingChatMessage = new OutgoingChatMessage(message);
    outgoingChatMessage.ChatMessageID = this._idGenerator.generateId();
    outgoingChatMessage.PersonType = PersonType.Operator;

    return outgoingChatMessage;
  }
}
